import { Component } from '@angular/core';
import { EnvironmentListService } from '@modules/common/services/environment-list.service';
import { CurrentEnvironmentService } from '@modules/common/services/current-environment.service';

@Component({
    selector: 'app-nav-header',
    templateUrl: './nav-header.component.html',
    styleUrls: ['./nav-header.component.scss']
})
export class NavHeaderComponent {
    public nonDefaultEnvironmentSelected = false;

    constructor(
        private _environmentListService: EnvironmentListService,
        private _currentEnvironmentService: CurrentEnvironmentService
    ) {
        this._currentEnvironmentService.environmentChanged.subscribe(() => this.updateEnvironment());
        this._environmentListService.environmentListChanged.subscribe(() => this.updateEnvironment());
    }

    private updateEnvironment(): void {
        const environmentName = this._currentEnvironmentService.getCurrentEnvironmentName();
        const environment = this._environmentListService.getEnvironmentList().filter(x => x.name.toLowerCase() == environmentName.toLowerCase())[0];
        this.nonDefaultEnvironmentSelected = environment && !environment.isDefault;
    }
}
